import { MenuNavmainController } from './lib/menu-navmain-controller.mjs'

new MenuNavmainController()
